export function classifyStock(variant, limits = {}) {
  const critical = Math.max(1, Number(limits.critical) || 5);
  const low = Math.max(critical, Number(limits.low) || 20);
  if (!variant?.available) return {level:'red', kind:'sold_out', pulse:false};
  if (!variant.inventoryTracked || variant.inventoryPolicy === 'continue') return {level:'green', kind:'available', pulse:false};
  const quantity = variant.inventoryQuantity;
  if (typeof quantity !== 'number' || !Number.isFinite(quantity)) return {level:'yellow', kind:'available', pulse:false};
  if (quantity <= 0) return {level:'red', kind:'sold_out', pulse:false};
  return {level:quantity < critical ? 'red' : quantity <= low ? 'yellow' : 'green', kind:'in_stock', pulse:true};
}

export function showStockCount(variant, limits = {}) {
  const critical = Math.max(1, Number(limits.critical) || 5);
  return Boolean(variant?.inventoryTracked && variant.inventoryPolicy !== 'continue' && Number.isFinite(variant.inventoryQuantity) && variant.inventoryQuantity < critical);
}

if (typeof document !== 'undefined') {
  const instances = new Map();
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-in-product]')];
    if (scope.matches?.('[data-in-product]')) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const status = root.querySelector('[data-in-status][data-stock-section]');
      const text = status?.querySelector('[data-in-stock-text]');
      const selector = root.querySelector('[data-in-variant]');
      const node = root.querySelector('[data-in-product-json]');
      if (!status || !text || !selector || !node) return;
      let data;
      try { data = JSON.parse(node.textContent); } catch { return; }
      const limits = {critical:status.dataset.stockCritical, low:status.dataset.stockLow};
      const labels = {in_stock:status.dataset.stockInText, sold_out:status.dataset.stockOutText, available:status.dataset.stockAvailableText};
      let variants = data.variants;
      const render = () => {
        const variant = variants.find(item => String(item.id) === selector.value);
        if (!variant) return;
        const state = classifyStock(variant, limits);
        const tracked = variant.inventoryTracked && Number.isFinite(variant.inventoryQuantity);
        const count = tracked ? Math.max(0, variant.inventoryQuantity) : null;
        const showCount = status.dataset.stockPreorder !== 'true' && showStockCount(variant, limits);
        status.hidden = false;
        status.dataset.stockLevel = state.level;
        status.dataset.stockKind = state.kind;
        status.dataset.stockVariant = String(variant.id);
        status.dataset.stockQuantity = tracked ? String(count) : '';
        status.dataset.stockPulse = String(state.pulse && status.dataset.stockAnimation === 'true');
        status.classList.toggle('is-unavailable', state.kind === 'sold_out');
        const label = showCount && (state.kind === 'in_stock' || count === 0)
          ? status.dataset.stockCountText.replace('__COUNT__', String(count))
          : labels[state.kind];
        if (text.textContent !== label) text.textContent = label;
      };
      const updated = event => {
        if (String(event.detail.productId) !== String(data.id)) return;
        variants = event.detail.variants;
        render();
      };
      selector.addEventListener('change', render);
      document.addEventListener('idolnest:inventory:updated', updated);
      instances.set(root, () => {
        selector.removeEventListener('change', render);
        document.removeEventListener('idolnest:inventory:updated', updated);
      });
      render();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) {
      if (root === event.target || event.target.contains(root)) { cleanup(); instances.delete(root); }
    }
  });
}
